// extracted by mini-css-extract-plugin
export default {"img":"Card_img__AxgLI","type":"Card_type__6NJcF","name":"Card_name__+QAmk","card":"Card_card__Ulp31"};